'use client';

import { Containers } from '@/components';
import { Widgets } from '@/components/widgets';

export default function ShopPlansPage() {
    return (
        <>
            <Containers.Section el={<Widgets.PlansHero />} />
            <Containers.Section el={<Widgets.PlansTabsWidget />} />
            <Containers.Section el={<Widgets.ReadToBuild />} />
        </>
    );
}
